<script setup lang="ts">
import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { KsButton, KsIcon, KsInput } from '@aschehoug/kloss'

const props = defineProps<{ subjectCode: SubjectCode, gradeCode: GradeCode, themeColor: string }>()

const { t } = useI18n()
const router = useRouter()

const searchQuery = ref('')

const doSearch = () => router.push({
  name: 'search',
  query: {
    fullText: searchQuery.value,
    grade: props.gradeCode,
    subject: props.subjectCode,
    fromSubject: props.subjectCode,
  },
})
</script>

<template>
  <section class="space-y-6 rounded-lg px-4 py-14 transition-all sm:px-8">
    <div class="mx-auto max-w-xl space-y-4">
      <h2
        class="text-center text-2xl font-bold"
        v-text="t('search.subject', { subject: t(`metadata.subjects.${subjectCode}`).toLowerCase() })"
      />
      <form
        role="search"
        class="relative"
        @submit.prevent="doSearch"
      >
        <KsIcon
          icon="magnifying-glass"
          class="absolute left-5 top-1/2 z-10 -translate-y-1/2 text-xl text-gray-50"
        />
        <KsInput
          v-model="searchQuery"
          type="text"
          maxlength="200"
          name="search"
          :aria-label="t('search.title')"
          :placeholder="t('search.placeholder')"
          shape="rounded"
          class="!rounded !bg-white !pl-16 !text-xl placeholder:text-lg placeholder:text-gray-40"
        />
        <KsButton
          class="absolute right-1.5 top-1/2 z-10 -translate-y-1/2 !rounded"
          :disabled="!searchQuery.length"
          variant="primary"
          type="submit"
        >
          {{ t('search.title') }}
        </KsButton>
      </form>
    </div>
  </section>
</template>
